import { RootState } from '../store';

export const getAccount = (store: RootState) => store.auth.account;
export const getIsMattressExpert = (store: RootState) => store.auth.isMattressExpert;
